import { z } from "zod";
// The wire's version (V6 plan 13.3.1 "Versions", H52): one number, 5.<minor>.<patch>, that
// health.check reports, every /api/v5 response carries as `v5-api-version`, and the OpenAPI
// document (contracts/openapi.json, GET /api/v5/openapi.json) names as info.version.
//
// The policy:
// - the major is the path's: 5 is /api/v5. A breaking change (a removed path, operation or
//   response field, a changed type, a newly required input, a changed meaning) is never made
//   here: it ships as /api/v6 beside v5;
// - an additive change (a new procedure or route, an optional input, an output field, an event
//   type, an enum member) bumps the minor;
// - a fix that changes the document and nothing a client may send or read (a description, a
//   summary) bumps the patch.
// `npm run verify:openapi` holds the policy: it fails when the generated document differs from
// the committed one, when the document changed against the base without a bump, and when it
// changed in a breaking way without a new major.
export const WIRE_VERSION = "5.38.0";
/** The wire's major, as the path names it. */
export const WIRE = "v5";
/** The response header every /api/v5 answer carries: WIRE_VERSION. */
export const WIRE_VERSION_HEADER = "v5-api-version";
/**
 * The response header every /api/v5 answer carries where the server knows its release
 * (V5_RELEASE_COMMIT, the commit the image was built from, as /readyz reports it): absent in
 * local development. A page that sees it change knows a newer release is live.
 */
export const RELEASE_HEADER = "x-v5-release";
/** The Claude Managed Agents beta the run events are shaped after (RunEventEnvelope.payload). */
export const CMA_BETA = "managed-agents-2026-04-01";
/** What health.check reports of the wire. */
export const ApiVersionSchema = z.object({
    wire: z.literal(WIRE).describe("The wire's major, as the path names it."),
    contracts: z
        .string()
        .regex(/^5\.\d+\.\d+$/)
        .describe("WIRE_VERSION: 5.<minor>.<patch>, the same as the v5-api-version header."),
    cmaBeta: z
        .string()
        .min(1)
        .describe("The Claude Managed Agents beta the run events' payloads are shaped after."),
});
/** The version health.check answers. */
export const API_VERSION = { wire: WIRE, contracts: WIRE_VERSION, cmaBeta: CMA_BETA };
//# sourceMappingURL=version.js.map